import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_IFIDischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_IFIDischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

                <p className="w-750">
                    <center><b>
                        Georgia Health Partners, LLC

                        <br />

                        Transition/Discharge Summary
                    </b>
                    </center>
                </p>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Name:</span>
                            <input type="date" id="txtName" name="txtName" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Date of Last Service</span>
                            <input type="date" id="dateLastService" name="dateLastService" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Date of Transition/Discharge:</span>
                            <input type="date" id="dischargeDate" name="dischargeDate" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Presenting Condition</span>
                    <span className="small block">(According to the "Presenting Condition" section of the Biopsychosocial Assessment that was completed upon admission)</span>
                    <textarea id="txtPresentingCondition" name="txtPresentingCondition" className="add-only "></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Extent to which goals and objectives were met</span>
                    <span className="small block">(According to the individual plans and progress reviews that were completed during programming. Please discuss EACH goal)</span>
                    <textarea id="txtExtentGoal" name="txtExtentGoal" className="add-only "></textarea>
                </p>


                <h2>Substance Abuse Assessment</h2>

                <span className="small block">(state "denied" if Individual denied past or current use)</span>

                <table>
                    <tr>
                        <td className="w-180"><span className="eleHeader">Substance Name</span></td>
                        <td className="w-100"><span className="eleHeader">Age of 1st Use</span></td>
                        <td className="w-150"><span className="eleHeader">Date of Last Use</span></td>
                        <td className="w-120"><span className="eleHeader">Frequency/ Amount</span></td>
                        <td className="w-180"><span className="eleHeader">Longest Period of Sobriety</span></td>
                    </tr>
                    <tr>
                        <td className='w-180'>Alcohol
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_1" name="txtAge_1" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_1" name="txtDate_1" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_1" name="txtSobriety_1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Cannabis
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_2" name="txtAge_2" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_2" name="txtDate_2" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_2" name="txtSobriety_2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Cocaine
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_3" name="txtAge_3" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_3" name="txtDate_3" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_3" name="txtSobriety_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Stimulants
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_4" name="txtAge_4" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_4" name="txtDate_4" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_4" name="txtSobriety_4" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Methamphetamine
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_5" name="txtAge_5" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_5" name="txtDate_5" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_5" name="txtFrequency_5" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_5" name="txtSobriety_5" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>LSD/PCP/Mushrooms
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_6" name="txtAge_6" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_6" name="txtDate_6" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_6" name="txtFrequency_6" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_6" name="txtSobriety_6" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Heroine/Methadone
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_7" name="txtAge_7" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_7" name="txtDate_7" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_7" name="txtFrequency_7" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_7" name="txtSobriety_7" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Steroids/Cough Syrup
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_8" name="txtAge_8" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_8" name="txtDate_8" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_8" name="txtFrequency_8" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_8" name="txtSobriety_8" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Tobacco
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_9" name="txtAge_9" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_9" name="txtDate_9" className="add-only" />
                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_9" name="txtFrequency_9" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_9" name="txtSobriety_9" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-180'>Prescription Meds
                        </td>
                        <td className='w-100 text-center'>
                            <input type="text" id="txtAge_10" name="txtAge_10" className="add-only" />
                        </td>
                        <td className='w-150 text-center'>
                            <input type="date" id="txtDate_10" name="txtDate_10" className="add-only" />

                        </td>
                        <td className='w-120 text-center'>
                            <input type="text" id="txtFrequency_10" name="txtFrequency_10" className="add-only" />
                        </td>
                        <td className='w-180 text-center'>
                            <input type="text" id="txtSobriety_10" name="txtSobriety_10" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Additional Information</span>
                    <textarea id="txtAdditionalInformation" name="txtAdditionalInformation" className=" add-only"></textarea>
                </p>

                <h2>Medications at discharge, if applicable</h2>
                <table>
                    <tr>
                        <td className="w-250"><span className="eleHeader w-250;">Type</span></td>
                        <td className="w-250"><span className="eleHeader w-250;">Strength</span></td>
                        <td className="w-250"><span className="eleHeader w-250;">Dosage</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtType_1" name="txtType_1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtStrength_1" name="txtStrength_1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtDosage_1" name="txtDosage_1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtType_2" name="txtType_2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtStrength_2" name="txtStrength_2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtDosage_2" name="txtDosage_2" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h2>Strengths, Needs, Abilities, Preferences</h2>
                <span className="small block">(Review this section of the Biopsychosocial Assessment and compare to the participants functioning at discharge. What changes have occurred in these areas as a result of program participation?)</span>

                <p className="w-750">
                    <span className="eleHeader">Strengths</span>
                    <textarea id="txtStrengths" name="txtStrengths" className=" add-only"></textarea>
                </p>

                <p className="w-750">
                    <span className="eleHeader">Need</span>
                    <textarea id="txtNeed" name="txtNeed" className=" add-only"></textarea>
                </p>

                <p className="w-750">
                    <span className="eleHeader">Abilities</span>
                    <textarea id="txtAbilities" name="txtAbilities" className=" add-only"></textarea>
                </p>
                <p className="w-750">

                    <span className="eleHeader">Preferences</span>
                    <textarea id="txtPreferences" name="txtPreferences" className="add-only"></textarea>

                </p>


                <h2>Individual Goals/Expectations Continued Services:  </h2>


                <p className="w-750">

                    <span className="eleHeader">Goal #1</span>
                    <textarea id="txtGoal_1" name="txtGoal_1" className="add-only"></textarea>

                </p>
                <p className="w-750">

                    <span className="eleHeader">Goal #2</span>
                    <textarea id="txtGoal_2" name="txtGoal_2" className="add-only"></textarea>

                </p>


                <h2>Verified Discharge Diagnosis</h2>

                <p className="w-750">
                    <textarea id="txtVerified" name="txtVerified" className="add-only"></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Reason for Discharge</span>
                    <span className="small block">(Check all that Apply)</span>
                </p>

                <table>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbCompletedProgram" name="cbCompletedProgram_1" className="add-only" value="1" />
                            Successfully completed program
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbLeftVoluntarily" name="cbLeftVoluntarily_1" className="add-only" value="1" />
                            Left voluntarily by choice
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbMoreIntense" name="cbMoreIntense_1" className="add-only" value="1" />
                            Referred/Transferred to more intense level of care
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbLessIntense" name="cbLessIntense_1" className="add-only" value="1" />
                            Referred/Transferred to a less intense level of care
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbProgram" name="cbProgram_1" className="add-only" value="1" />
                            Lack of progress, program initiated
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbParticipant" name="cbParticipant_1" className="add-only" value="1" />
                            Lack of progress, participant initiated
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbViolation" name="cbViolation_1" className="add-only" value="1" />
                            Program rule violation
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbMedicalProblem" name="cbMedicalProblem_1" className="add-only" value="1" />
                            Medical Problem, unable to participate
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbLegalProgram" name="cbLegalProgram_1" className="add-only" value="1" />
                            Legal Problem/Situation, unable to participate
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbGeographic" name="cbGeographic_1" className="add-only" value="1" />
                            Change in geographic/living location
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbInsuranceChange" name="cbInsuranceChange_1" className="add-only" value="1" />
                            Insurance Change
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbReason_Other" name="cbReason_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtReason_Other" name="txtReason_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Status of Recovery Goals at Discharge</span>
                </p>
                <table>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAccomplished" name="cbAccomplished_1" className="add-only" value="1" />
                            Accomplished
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbSignificantProgress" name="cbSignificantProgress_1" className="add-only" value="1" />
                            Significant Progress
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbModerateProgress" name="cbModerateProgress_1" className="add-only" value="1" />
                            Moderate Progress
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMinorProgress" name="cbMinorProgress_1" className="add-only" value="1" />
                            Minor Progress
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbNoProgress" name="cbNoProgress_1" className="add-only" value="1" />
                            No Progress
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Recommendation for Ongoing Service Type</span>
                </p>
                <table>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbCSI" name="cbCSI_1" className="add-only" value="1" />
                            CSI
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbNursing" name="cbNursing_1" className="add-only" value="1" />
                            Nursing
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbCSU" name="cbCSU_1" className="add-only" value="1" />
                            CSU
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbPractitioner" name="cbPractitioner_1" className="add-only" value="1" />
                            Private Practitioner/Private MD
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbFamilyTherapy" name="cbFamilyTherapy_1" className="add-only" value="1" />
                            Family Therapy
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbGroupTherapy" name="cbGroupTherapy_1" className="add-only" value="1" />
                            Group Therapy
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbIndividualTherapy" name="cbIndividualTherapy_1" className="add-only" value="1" />
                            Individual Therapy
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbPRTF" name="cbPRTF_1" className="add-only" value="1" />
                            PRTF (Psychiatric Residential Treatment Facility)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentorProgram" name="cbMentorProgram_1" className="add-only" value="1" />
                            Mentor Program
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbMedManagement" name="cbMedManagement_1" className="add-only" value="1" />
                            Psychiatric Services and Med Management
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbPsychologicalTesting" name="cbPsychologicalTesting_1" className="add-only" value="1" />
                            Psychological Testing
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbType_Other" name="cbType_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtType_Other" name="txtType_Other1" className="add-only " />
                        </td>
                    </tr>
                </table>
                <h2>Recommended Support Systems and Services/Referrals</h2>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Person/Agency</span>
                            <input type="text" id="txtPersonAgency" name="txtPersonAgency" className="add-only " />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Location/Address</span>
                            <input type="text" id="txtLocationAddress" name="txtLocationAddress" className="add-only " />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Phone Number</span>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className="add-only " />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Contact Person</span>
                            <input type="text" id="txtContactPerson" name="txtContactPerson" className="add-only " />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">First (or next) Appointment (time and date, if known)</span>
                            <input type="date" id="txtFirstAppointment" name="txtFirstAppointment" className="add-only" />
                        </td>
                    </tr>
                </table>

                <h2>Community Linkages Provided During Course of Services:</h2>
                <table>

                    <tr>
                        <td className='w-150'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Type of Organization:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contact Info:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Status of Involvement:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtOrganization_1' name='txtOrganization_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtContact_1' name='txtContact_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtInvolvement_1' name='txtInvolvement_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtOrganization_2' name='txtOrganization_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtContact_2' name='txtContact_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtInvolvement_2' name='txtInvolvement_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtOrganization_3' name='txtOrganization_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtContact_3' name='txtContact_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtInvolvement_3' name='txtInvolvement_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtOrganization_4' name='txtOrganization_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtContact_4' name='txtContact_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtInvolvement_4' name='txtInvolvement_4' className='add-only' /> </td>
                    </tr>

                </table>

                <p className="w-750">

                    <span className='eleHeader'>Aftercare Plan: </span>
                    <span className='small'> (Include an ongoing relapse prevention plan, safety plan, identify names and numbers of support system at home, community, school etc.  This section is to be completed, in final sessions, with the Individual and family.  Include ongoing recommendations for treatment. Include any support groups, NA/AA/CA/Alateen, tutoring, and replacement activities) </span>

                    <textarea id='txtAftercarePlan' name='txtAftercarePlan' className='add-only'></textarea>
                </p>

                <h2>Discharge Summary Completed by</h2>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Print Name and Credentials: </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature and Credentials: </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Individual/Parent Signature: </td>
                    </tr>




                </table>
            </div>
        </form>
    )
}